import { render, staticRenderFns } from "./EnumerationPoint.vue?vue&type=template&id=ee5d8ce4&"
import script from "./EnumerationPoint.vue?vue&type=script&lang=js&"
export * from "./EnumerationPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TitleWithSubtitle: require('/vercel/path0/components/componentloader/TitleWithSubtitle.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default})
